export enum ActionTypes {
  AUTH_LOGIN = 'AUTH_LOGIN',
  AUTH_LOGOUT = 'AUTH_LOGOUT',
  USER_REQUEST = 'USER_REQUEST',
  REDIRECT_LOGIN = 'REDIRECT_LOGIN',
  LOAD_EDITORIAL_PROJECTS = 'LOAD_EDITORIAL_PROJECTS',
  LOAD_ELEMENT_TYPES = 'LOAD_ELEMENT_TYPES',
  SHOW_TOAST = 'SHOW_TOAST',
  GET_ELEMENT_STATUS_TYPES = 'GET_ELEMENT_STATUS_TYPES',
  GET_ELEMENT_STATUS_PHASES = 'GET_ELEMENT_STATUS_PHASES'
}
